import { Menu as MuiMenu, MenuProps as MuiMenuProps } from '@mui/material'
import styled from 'styled-components'

export type MenuPropsType = MuiMenuProps

const Menu = styled(MuiMenu)<MenuPropsType>``

export default Menu
